<template>

<div>
<div v-if="this.screenwidth > 979">

    <el-card style="margin: 100px 6% 6%">
      <div style="text-align:center; padding-top:8%;">
        <h1>Thanks for registering!</h1>
        <h1>Please check your email to confirm your account.</h1>
      <h2 style="margin-top: 90px;
        margin-bottom: 50px;"> please allow up to a few minutes for the email to arrive, also please check in your promotions folder.</h2>
        <router-link :to="{ path: 'ResendRegisterEmail' }">Didn't get email?</router-link>

        <!-- <ResendRegistrationConfirmationEmail /> -->
      </div>
    </el-card>
</div>

<div v-else>
        <div style="text-align:center; padding-top:8%;">
        <h1>Thanks for registering!</h1>
        <h1>Please check your email to confirm your account.</h1>
      <h2 style="margin-top: 90px;
        margin-bottom: 50px;"> please allow up to a few minutes for the email to arrive, also please check in your promotions folder.</h2>
        <router-link :to="{ path: 'ResendRegisterEmail' }">Didn't get email?</router-link>

      </div>
</div>

</div>
</template>

<script>
//import ResendRegistrationConfirmationEmail from "@/components/account/ResendRegistrationConfirmationEmail.vue";

export default {
  components: {
   // ResendRegistrationConfirmationEmail
  },
    computed: {
    screenwidth: function() {
      return document.documentElement.clientWidth;
    }
  }
};
</script>

<style scoped>

</style>
